import Table from "./table.jsx";

export default Table;



// WEBPACK FOOTER //
// ./src/components/pages/Create/universe_lite/Analyze/table/index.js